import { createTheme } from '@material-ui/core/styles';

export const createXDomeTheme = () => {
   return createTheme({
      props: {
         MuiButton: {
            disableElevation: true,
         },
      },
      typography: {
         fontFamily: 'Open Sans',
         body1: {
            fontSize: 12
         },
         button: {
            textTransform: 'none'
         },
         h1: {
            fontWeight: 600,
            fontSize: 40
         },
         h2: {
            fontWeight: 300,
            fontSize: 24
         },
         h3: {
            fontWeight: 300,
            fontSize: 20
         },
         h4: {
            fontWeight: 300,
            fontSize: 17
         },
         h5: {
            fontWeight: 300,
            fontSize: 13
         },
      },
      overrides: {
         MuiButtonBase: {
            root: {
               '&': {
                  transition: 'none !important',
                  animation: 'none !important',
               },
               '&:focus': {
                  outline: '2px solid black',
                  outlineOffset: '-2px',
                  animation: 'none !important',
               },
               '&:focus-visible': {
                  outline: '2px solid black',
                  outlineOffset: '-2px',
                  animation: 'none !important',
               },
               '&:focus:not(:focus-visible)': {
                  outline: 'none',
                  animation: 'none !important',
               }
            },
         },
         MuiButton: {
            root: {
               transition: 'none !important',
               '&:focus': {
                  outline: '2px solid black',
                  outlineOffset: '2px',
                  animation: 'none !important',
               },
               '&.Mui-disabled': {
                  pointerEvents: 'inherit',
               },
            },
         },
         MuiIconButton: {
            root: {
               transition: 'none !important',
               '&:focus': {
                  outline: '2px solid black',
                  outlineOffset: '2px',
                  animation: 'none !important',
               },
            },
         },
         MuiLink: {
            root: {
               transition: 'none !important',
               '&:focus': {
                  outline: '2px solid black',
                  outlineOffset: '2px',
                  textDecoration: 'none',
                  animation: 'none !important',
               },
            },
            button: {
               color: "#2196f3",
            },
            underlineNone: {
               '&:hover': {
                  color: '#2e9e9e'
               }
            }
         },
         MuiInputBase: {
            root: {
               transition: 'none !important',
               '&.Mui-focused': {
                  '& fieldset': {
                     borderColor: 'black !important',
                     transition: 'none !important',
                  },
               },
               '&.Mui-disabled': {
                  color: 'rgba(0,0,0,.42) !important',
                  cursor: 'not-allowed !important',
               },
            },
         },
         MuiFormLabel: {
            root: {
               '&.Mui-disabled': {
                  color: 'rgba(0,0,0,.42) !important',
                  cursor: 'not-allowed !important',
               },
            },
         },
         MuiCheckbox: {
            root: {
               transition: 'none !important',
               '&.Mui-focusVisible .MuiIconButton-label': {
                  outline: '2px solid black',
                  outlineOffset: '2px',
                  animation: 'none !important',
               },
               '&.Mui-disabled': {
                  color: 'rgba(0,0,0,.42) !important',
                  cursor: 'not-allowed !important',
               },
            },
         },
         MuiRadio: {
            root: {
               transition: 'none !important',
               '&.Mui-focusVisible .MuiIconButton-label': {
                  outline: '2px solid black',
                  outlineOffset: '2px',
                  animation: 'none !important',
               },
            },
         },
         MuiSelect: {
            root: {
               '&.Mui-disabled': {
                  color: 'rgba(0,0,0,.42) !important',
                  cursor: 'not-allowed !important',
               },
            },
         },
         MuiSwitch: {
            root: {
               transition: 'none !important',
               '&.Mui-focusVisible .MuiSwitch-thumb': {
                  outline: '2px solid black',
                  outlineOffset: '2px',
                  animation: 'none !important',
               },
            },
         },
         MuiTouchRipple: {
            root: {
               display: 'none',
            },
         },
         MuiTypography: {
            root: {
               // Applies only when Typography uses color="error"
               '&.MuiTypography-colorError': {
                  color: '#c44040',
               },
            },
         },
      },
      palette: {
         primary: {
            main: '#186ea8'
         },
         secondary: {
            main: '#1f6a6a'
         }
      }
   })
}